import type { ApiEffect } from '../../index.h'
import type { MotnMovie, MotnSearchResult, MotnSeries } from './index.h'

import { createEffect } from 'effector'
import { abortFeature } from '../../lib/abort'

const { createAbortableEffect } = abortFeature()

// GET /movienight/{service}/series
export const getMovieNightSeriesFx: ApiEffect<
  { service: string },
  MotnSeries[]
> = createEffect()

// GET /movienight/{service}/movie
export const getMovieNightMoviesFx: ApiEffect<
  { service: string },
  MotnMovie[]
> = createEffect()

// GET /movienight/search (abortable: new search aborts the previous request)
export const [getMovieNightSearchFx, getMovieNightSearchAbortableFx] =
  createAbortableEffect<{ q: string }, MotnSearchResult>({ autoAbort: true })
